import * as React from 'react';

export default class ScreenDimensionProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            height: '0',
            width: '0',
        }
    }
    
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    
    render() {
        return this.props.render(this.state.width, this.state.height);
    }
}


// WEBPACK FOOTER //
// ./src/ScreenDimensionProvider.js